import { useMutation } from "@tanstack/react-query";
import type { ColumnFiltersState } from "@tanstack/react-table";
import { apiClient } from "../../../../zodios/client";
import { useDates } from "../../../../dates/DatesContext";

export const useV4OrgReportExport = (filters: ColumnFiltersState, marketPlace: string) => {
  const { start, end } = useDates();
  return useMutation({
    mutationFn: async () =>
      await apiClient.getV4OrgReportExport({
        queries: {
          start_date: start.toISOString(),
          end_date: end.toISOString(),
          marketplace: marketPlace,
          report_type: "org_report",
          filters:
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            filters as any,
        },
        responseType: "blob",
      }),
  });
};
